import Path from 'path';
import { FileLoadState } from './types';

export function formatPathByFilename(filename: string, rootpath: string) {
  return `${rootpath.replace(/\/$/, '')}/${filename.replace(/^\//, '')}`;
}

export function checkIsBinary(ext: string) {
  const list = 'jpg jpeg png gif xls xlsx zip doc docx svg';
  if (list.split(' ').indexOf(ext) > -1) {
    return true;
  }
  return false;
}

export function download(data: { url: string; name: string }) {
  const downloadLink = document.createElement('a');
  downloadLink.href = data.url;
  downloadLink.download = data.name;
  downloadLink.click();
}

export function makeFile<File>(file: {
  path: string;
  downloadUrl: string;
  name?: string;
  isDir?: boolean;
  isSelected?: boolean;
  content?: string;
  isFromPrelude?: boolean;
}) {
  return {
    name: Path.basename(file.path),
    content: '',
    size: 0,
    isDir: false,
    lastModified: '',
    isFromPrelude: false,
    isDeleted: false,
    isSelected: false,
    loadState: FileLoadState.fulfilled,
    ...file
  };
}
